import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../src/AdminAuthContext";
import logo from "../src/images/dc_logo.png";
import logovc from "../src/images/loginbg.jpg";
import "././loginComponents/Login.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const { adminLogin } = useAdminAuth();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
      const adminData = localStorage.getItem("adminData");
      if (adminData) {
          // Redirect to the home or dashboard page if adminData is present
          navigate("/admin-panel");
      }
  }, [navigate]);

    // Get the return URL or default to the home page
    const returnUrl = location.state?.returnUrl || "/admin-panel/";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMessage("");

        try {
            const response = await axios.post(`${BASE_URL}/adminLogin.php`, { email, password });

            const data = await response.data;

            if (data.success) {
                // Save admin info to the AuthContext or localStorage
                adminLogin(data.admin);
                alert("Login successful!");
                navigate(returnUrl, { replace: true }); // Redirect to the original page
            } else {
                setErrorMessage(data.error || "Invalid credentials. Please try again.");
            }
        } catch (error) {
            console.error("Login error:", error);
            setErrorMessage("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="login-bg">
            <div className="login-container">
                <div className="login-box">
                    <div className="logo">
                        <img src={logo} alt="Logo" />
                    </div>
                    <form className="login-form" onSubmit={handleSubmit}>
                        <h1>Login</h1>
                        <div className="input-group">
                            <label htmlFor="email">Email</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                required
                            />
                        </div>
                        <div className="input-group">
                            <label htmlFor="password">Password</label>
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                required
                            />
                        </div>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                        <button type="submit" className="login-button">Login</button>
                    </form>
                </div>
                <div className="logo-vc-area">
                    <img src={logovc} alt="logo_vector" />
                </div>
            </div>
        </div>
    );
}

export default Login;
